import player from './parts/athletes/player_detail/player'
import feature from './parts/athletes/player_detail/feature'

(() => {
  player();
  feature();
})();


